import * as React from 'react';
import Panel from './Panel';
import Connection from './Connection/index';
import {GameLobbyState, OtherPlayer} from './AppTypes';

interface LobbyProps {
    lobby?: GameLobbyState;
}

export class GameLobby extends React.Component<LobbyProps> {
    public render(): JSX.Element {
        if (!this.props.lobby) {
            return <div>unexpected...</div>;
        }
        return (
            <div className="App-panels">
                <Panel>
                    <div className="joining">
                        <p>Waiting for players...</p>
                        <p>
                            <b>{this.props.lobby.mapName}</b>
                        </p>
                        <ul>
                            {this.playerSlots(this.props.lobby).map((player, i) => (
                                <li key={i}>{player ? player.name : '[waiting...]'}</li>
                            ))}
                        </ul>
                        <button onClick={this.playWithBots} type="button">
                            Add bot(s) to play now
                        </button>
                        <button onClick={this.cancel} type="button">
                            Go back to the lobby
                        </button>
                    </div>
                </Panel>
            </div>
        );
    }

    private playerSlots(lobby: GameLobbyState): (OtherPlayer | undefined)[] {
        const slots: (OtherPlayer | undefined)[] = [];
        for (let i = 0; i < lobby.playerCount; i++) {
            const player = lobby.players[i];
            slots.push(player);
        }
        return slots;
    }

    private playWithBots(): void {
        Connection.send('playWithBots', {});
    }

    private cancel(): void {
        Connection.send('cancel', {});
    }
}



// WEBPACK FOOTER //
// ./src/GameLobby.tsx